import { render, staticRenderFns } from "./index.vue?vue&type=template&id=86f45e2a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=86f45e2a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86f45e2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('86f45e2a')) {
      api.createRecord('86f45e2a', component.options)
    } else {
      api.reload('86f45e2a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=86f45e2a&scoped=true", function () {
      api.rerender('86f45e2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/distribution/storeGuarantee/index.vue"
export default component.exports